export enum BODY_STYLE_CREATION_OPTION {
  UPDATE_BODY_STYLE_INFORMATION = 'updateBodyStyleInformation',
}
